import { render, staticRenderFns } from "./teachersQueryNew.vue?vue&type=template&id=4ca3b3af"
import script from "./teachersQueryNew.vue?vue&type=script&lang=js"
export * from "./teachersQueryNew.vue?vue&type=script&lang=js"
import style0 from "./teachersQueryNew.vue?vue&type=style&index=0&id=4ca3b3af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports